import { touchevents } from 'modernizr';
import {
    SET_VIEWPORT,
} from 'vue/vuex/mutation-types';

import * as getters from './getters';
import * as actions from './actions';

/**
 * The mutations available in the module
 */
const mutations = {
    [SET_VIEWPORT](state, { width, height, mq }) {
        state.viewport = {
            width,
            height,
            mq,
            touchevents: state.viewport.touchevents,
        };
    },
};

/**
 * The state of the module
 */
const state = {
    viewport: {
        height: 0,
        width: 0,
        touchevents,
        mq: {},
    },
};


export default {
    actions,
    state,
    getters,
    mutations,
};



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/vue/vuex/modules/viewport/index.js